import React, { Component } from 'react';
import {Link} from 'react-router-dom';
import '../App.css';

import EndOfProject from './EndOfProject';

import cooper from '../Images/cooper-image.jpg';
import cooper_1 from '../Images/cooper-1.jpg';
import cooper_2 from '../Images/cooper-2.jpg';
import cooper_3 from '../Images/cooper-3.jpg';
import cooper_4 from '../Images/cooper-4.jpg';
import cooper_5 from '../Images/cooper-5.jpg';

import code_icon from '../Images/code-icon.svg';
import pencil_icon from '../Images/pencil-icon.svg';
import arrow_icon from '../Images/arrow-icon.svg';
import bucket_icon from '../Images/bucket-icon.svg';

class ProjectCooperheadArt extends Component {
  
    constructor(props) {
        super();
        this.props = props;
    }
  
  componentDidMount() {
    window.scrollTo(0, 0);
  }

  componentWillUnmount(){

  }

  visitWebsite() {
    window.open("https://cooperheadart.com", "_blank");
  }

  render () {
    
    const footerYear = new Date().getUTCFullYear();

    return (
        
      <div id="project">

        <div className="project-content-top">
          
            <p className="project-title-large">Cooperhead Art: Design and Dev of a Painter's Website</p>
            <img className="project-image-rounded-2" src={cooper} alt=""></img>

            <div className="project-text-container">
              <p className="project-text-medium">Summary</p>
            </div>
            <div className="project-overview">
              <div className="project-overview-left">
                <div className="project-text-container-2">
                  <p className="project-text-small">Mission</p>
                  <p className="project-paragraph">A client requested a website for displaying his artwork with functionality allowing him to manage the website images from time to time.</p>
                </div>
                <div className="project-text-container-2">
                  <p className="project-text-small">My Contributions</p>
                  <p className="project-paragraph">I provided the client with a completed website I designed and developed in React, integrated with AWS S3 Bucket. I gave the client control of the website images by granting him access credentials to the AWS S3 Bucket. The client was satisfied with the ability to easy drag and drop files into the bucket for easy website content management. </p>
                </div>
              </div>
              <div className="project-overview-right">
                <div className="project-text-container-3">
                  <p className="project-text-small">Link</p>
                  <div className="button" onClick={(e) => {this.visitWebsite()}}>
                    <p>CooperheadArt.com</p>
                    <img className="button-icon" src={arrow_icon} alt=""></img>
                  </div>
                </div>

                  <div className="project-text-container-3">
                    <p className="project-text-small">My Tasks</p>

                    <div className="icon-bullet">
                      <img className="bullet-icon" src={pencil_icon} alt=""></img>
                      <p className="project-paragraph">Web Design</p>
                    </div>
                    <div className="icon-bullet">
                      <img className="bullet-icon" src={code_icon} alt=""></img>
                      <p className="project-paragraph">Web Development</p>
                    </div>
                    <div className="icon-bullet">
                      <img className="bullet-icon" src={bucket_icon} alt=""></img>
                      <p className="project-paragraph">AWS S3 Bucket</p>
                    </div>
                  </div>

              </div>
            </div>
        </div>

        <div className="project-content">

          <div className="project-chunk">
            <div className="project-text-container">
              <p className="project-text-medium">Website</p>
              <p className="project-paragraph">The website serves to promote the painter's artwork and share his life experience.</p>
            </div>
            <img className="project-image-sidepadded" src={cooper_1} alt=""></img>
          </div>

          <div className="project-chunk">
            <div className="project-text-container">
              <p className="project-text-medium">Content Management</p>
              <p className="project-paragraph">The client wanted a way to change images on the website from time to time. I set up an AWS S3 Bucket where the client can easily drag and drop new images.</p>
            </div>
            <img className="project-image-bordered" src={cooper_2} alt=""></img>
          </div>

          <div className="project-chunk">
            <div className="project-text-container">
              <p className="project-text-medium">Sketches</p>
              <p className="project-paragraph">I designed the webpages with this clipboard and grid paper to brainstorm the navigation, page layout, and color.</p>
            </div>
            <img className="project-image-sidepadded" src={cooper_3} alt=""></img>
            <img className="project-image-sidepadded" src={cooper_4} alt=""></img>
          </div>

          <div className="project-chunk">
              <div className="project-text-container">
                <p className="project-text-medium">Client Communication</p>
                <p className="project-paragraph">We communicated over text as the client liked for quick turn-arounds and getting things done. </p>
            </div>
            <img className="project-image-sidepadded" src={cooper_5} alt=""></img>
          </div>

        <EndOfProject/>
  
        </div>
        
      </div>
    );
  }
}

export default ProjectCooperheadArt;
